module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "card-title semibold px-2 py-2"
  }, [_vm._v("\n    Item Summary\n  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "px-2 py-2"
  }, [_c('item-summary', {
    attrs: {
      "item": _vm.project
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.hasFiles) ? _c('div', {
    staticClass: "px-2 py-2"
  }, [(_vm.project.file.files.preview) ? _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.preview, true)
      }
    }
  }, [_vm._v("Preview File")])]) : _vm._e(), _vm._v(" "), (_vm.project.file.files.cover) ? _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.cover, true)
      }
    }
  }, [_vm._v("Cover File")])]) : _vm._e(), _vm._v(" "), (_vm.project.file.files.content) ? _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.content, true)
      }
    }
  }, [_vm._v("Content File")])]) : _vm._e(), _vm._v(" "), (_vm.project.file.files.original) ? _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveItem(_vm.project.file.files.original, true)
      }
    }
  }, [_vm._v("Original File")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasFiles) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center-align px-2 py-4"
  }, [_c('fancy-price', {
    attrs: {
      "price": _vm.unitPrice()
    }
  }, [_vm._v(_vm._s(_vm.nextPrice()))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "cart-control center-align"
  }, [_c('v-icon', {
    on: {
      "mousedown": function($event) {
        return _vm.changeQuantity(-1)
      }
    }
  }, [_vm._v("mdi-minus")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantity),
      expression: "quantity"
    }],
    staticClass: "quantity",
    attrs: {
      "name": "quantity",
      "size": "4",
      "maxlength": "3",
      "placeholder": "QTY",
      "mast": "###"
    },
    domProps: {
      "value": (_vm.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-icon', {
    on: {
      "mousedown": function($event) {
        return _vm.changeQuantity(1)
      }
    }
  }, [_vm._v("mdi-plus")])], 1)])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": _vm.valid ? 'primary' : 'disabled',
      "depressed": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.updateCart(_vm.project.id, _vm.quantity)
      }
    }
  }, [_vm._v("Process Order")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a85297e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/proxy/create/summary.vue
// module id = 715
// module chunks = 1